import React, { Component } from "react";

import { copyright } from "../data/copyright";

import Skeleton from "@material-ui/lab/Skeleton";

class ImageSkeleton extends Component {
  state = {
    progress: true,
  };

  progressEnd = () => {
    this.setState({ progress: false });
  };

  render() {
    return (
      <div
        className={this.props.className}
        style={
          this.state.progress
            ? { position: "relative" }
            : { position: "relative", cursor: "pointer" }
        }
        onClick={this.state.progress && this.props.func ? "" : this.props.func}
      >
        {this.state.progress ? (
          <Skeleton
            variant="rect"
            width={this.props.width}
            height={this.props.height}
            style={{ position: "absolute" }}
          />
        ) : null}
        <div>
          <div
            style={
              this.props.classNameImg
                ? { overflow: "hidden", height: this.props.height }
                : {}
            }
          >
            <img
              onLoad={() => this.progressEnd()}
              onError={() => this.progressEnd()}
              className={`${this.props.className} ${this.props.classNameImg}`}
              src={this.props.src}
              alt=""
              style={{ background: "White" }}
            />
          </div>
          {copyright.includes(this.props.src) ? (
            <div
              style={{
                backgroundColor: "rgba(255,255,255,0.7)",
                position: "absolute",
                bottom: 0,
                right: 0,
                padding: "0 5px",
                fontSize: "9pt",
                textAlign: "right",
              }}
            >
              Foto: Angelika Brockmann-Peschel, © LWL-DLBW
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default ImageSkeleton;
